// Фактура над стокови в листа „Доставка": стоковите без фактура на доставчика
// (банерът „Избери стокови" и модалът), избраните (`linkedNoteIds`) и
// заредените отделно вече свързани (редакция — те не са сред „без фактура").
// `invoiceNotes` са избраните, докато документът е фактура — редовете и
// сумите им влизат в решетката и в тоталите (`notesSum`).
import { useState } from "react";
import type { Delivery, DeliveryDocumentType } from "../../../../api/inventory";
import { useUninvoicedNotes } from "../../../../hooks/useInventoryDeliveries";
import { linkedNotesSummary } from "./deliveryMeta";

type Params = {
  documentType: DeliveryDocumentType;
  supplierId: number | null;
  initialNoteIds: number[];
};

export const useInvoiceNotes = ({ documentType, supplierId, initialNoteIds }: Params) => {
  const isInvoice = documentType === "invoice";
  const { data: uninvoicedAll = [] } = useUninvoicedNotes(null, isInvoice);
  // стоковите без доставчик могат да влязат във фактура на всеки доставчик
  const notesOfSupplier = uninvoicedAll.filter(
    (note) => supplierId == null || note.supplierId == null || note.supplierId === supplierId,
  );
  const [linkedNoteIds, setLinkedNoteIds] = useState<number[]>(initialNoteIds);
  const [linkedNotesExtra, setLinkedNotesExtra] = useState<Delivery[]>([]);
  const findNote = (id: number) =>
    notesOfSupplier.find((note) => note.id === id) ?? linkedNotesExtra.find((note) => note.id === id);
  const linkedNotes = linkedNoteIds.map(findNote).filter((note): note is Delivery => !!note);
  const invoiceNotes = isInvoice ? linkedNotes : [];
  return {
    notesOfSupplier,
    // за модала „Кои стокови обобщава фактурата?" — и вече свързаните
    pickerNotes: [
      ...notesOfSupplier,
      ...linkedNotesExtra.filter((extra) => !notesOfSupplier.some((note) => note.id === extra.id)),
    ],
    linkedNoteIds,
    setLinkedNoteIds,
    setLinkedNotesExtra,
    linkedNotes,
    hasLinkedNotes: linkedNotes.length > 0 || linkedNoteIds.length > 0,
    invoiceNotes,
    notesSum: linkedNotesSummary(invoiceNotes),
  };
};
